module.exports = __webpack_public_path__ + "images/custom-trigger-icon-9441dbb8.svg";